<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col>
          <div v-html="this.textPointStuff" />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { PointStuffTranslateVariables } from "@/views/loyalty/models/justpay-pointStuff.model"
import { JustpayPointStuffService } from "@/views/loyalty/shared/services/justpay-pointStuff-service"

export default {
  data: () => ({
    textPointStuff: null
  }),
  async beforeMount () {
    console.log('this.$route.query.id', this.$route.query.id)
    console.log('this.$route.query.var', this.$route.query.var)
    const justpayPointStuffService = new JustpayPointStuffService()
    // const pointStuffId = this.$route.query.id
    const pointVar = this.$route.query.var
    this.textPointStuff = await justpayPointStuffService.getPointStuff(this.$route.query.id, pointVar)
    console.log('textPointStuff', this.textPointStuff)
  }
}
</script>

<style scoped>

</style>
